import React, {useState, useEffect} from 'react';
import { Container, Nav, Dropdown, Navbar, Button } from 'react-bootstrap';
import {Connection} from '@solana/web3.js'
import {ThemeConfig, writeDarkSwitch} from 'bootstrap-darkmode';
import { TOKENS } from "../constants/constants"
import {
    useWallet
} from '@solana/wallet-adapter-react';
import { useAppSelector, useAppDispatch } from '../hooks'
import {
    WalletDisconnectButton
} from '@solana/wallet-adapter-react-ui';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { getTokenBalance } from "../redux/tokenAction"
import {setWallet, setSolBalance, setToken, toggleSound, toggleDarkMode, toggleUserAnalytics, toggleHistoricalAnalytics, setMode, setTokenBalances} from '../redux/reducers/storageSlice'


const TokenSelect: React.FC = () => {

    const dispatch = useAppDispatch();
    const solBalance = useAppSelector(state => state.storage.solBalance)
    const mode = useAppSelector(state => state.storage.mode)
    const darkmode = useAppSelector(state => state.storage.darkmode)
    const sound = useAppSelector(state => state.storage.sound)
    const connection = new Connection(process.env.REACT_APP_RPC_URL, "confirmed");
    const walletConnected = useAppSelector((state) => state.storage.wallet)
    const selectedToken = useAppSelector((state) => state.storage.token)
    const tokenBalances = useAppSelector((state) => state.storage.tokenBalances)

    const onChange = (val) => {
        if (val == "SOL"){
            dispatch(setMode("SOL"))
            dispatch(setToken("SOL"))
        } else {
            dispatch(setMode("Token"))
            dispatch(setToken("POGR"))  
        }

    }

    return (
        <Dropdown onSelect={(val) => {onChange(val)}}>
          <Dropdown.Toggle variant="light" size="lg" id="dropdown-basic" >
            <img alt="not found" src={`https://multiflip.io/images/${selectedToken}.png`} width={20}
                style={{
                    top: "-2px",
                    position: "relative",
                    marginRight: 5,
                }}
            /> {selectedToken} {selectedToken != "SOL" ? tokenBalances[selectedToken] : solBalance}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="SOL">
                <img alt="not found" src={`https://multiflip.io/images/SOL.png`} width={20}
                style={{
                    top: "-2px",
                    position: "relative",
                    marginRight: 5,
                }}       
                />     
                SOL {solBalance}
            </Dropdown.Item>
            <Dropdown.Item eventKey="POGR">
                <img alt="not found" src={`https://multiflip.io/images/POGR.png`} width={20}
                style={{
                    top: "-2px",
                    position: "relative",
                    marginRight: 5,
                }}
                /> POGR {tokenBalances["POGR"]}                
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
    );
};

export default TokenSelect;